module.exports = __webpack_public_path__ + "static/media/Arrow-Circle-Disabled.ee377941.svg";